import { createSelector } from "reselect";

export const getBudget = createSelector(
	[(state) => state.budget],
	(budget) => budget,
);

export const getBudgetConfig = createSelector(
	[(state) => state.budget.config],
	(config) => config,
);

export const getBudgetError = createSelector(
	[(state) => state.budget.error],
	(error) => error,
);

export const getBudgetOverview = createSelector([(state) => state], (state) => {
	const {
		budget,
		selection,
		core: { area, nodes },
	} = state;
	let plotPrice = 0;
	let auxiliaries = 0;
	if (selection.plot) {
		plotPrice = roundToNearest(
			selection.budget * budget.blocker.factor(selection.budget),
		);
	}

	const optionsPrice = nodes.reduce((price, node) => {
		if (selection.nodes.includes(node.id) && node.price > 0) {
			if (node.pricePerArea) {
				return roundToNearest(price + node.price * area);
			}
			return roundToNearest(price + node.price);
		}
		return price;
	}, 0);

	if (optionsPrice > 0) {
		auxiliaries = roundToNearest(((plotPrice + optionsPrice) / 0.88) * 0.12, 3);
	} else {
		auxiliaries = roundToNearest(selection.budget * 0.12, 3);
	}

	return {
		ignore: budget.config.ignore,
		increment: budget.config.increment,
		currency: budget.config.currency,
		total: selection.budget,
		plotPrice,
		auxiliaries,
		optionsPrice,
		totalReached: plotPrice + optionsPrice + auxiliaries,
	};
});

export function roundToNearest(number, position = 3) {
	const multiplier = 10 ** position;
	return Math.round(number / multiplier) * multiplier;
}



// WEBPACK FOOTER //
// ./src/modules/budget/selectors.js